/* Bandenmeesters 2.1 — mega-menu accessibility helper.
   Visual opening remains native CSS hover/focus; this script only mirrors state and Escape behavior. */
(()=>{
  if(window.__bmMegaMenuRuntime)return;
  window.__bmMegaMenuRuntime=true;

  const init=(scope=document)=>{
    scope.querySelectorAll('.navigation-main>.navigation-item:has(>.bm-v2-mega)').forEach(item=>{
      if(item.dataset.bmMegaReady==='true')return;
      item.dataset.bmMegaReady='true';
      const trigger=item.querySelector(':scope>a[data-bm-mega-trigger]');
      if(!trigger)return;

      const setExpanded=value=>trigger.setAttribute('aria-expanded',value?'true':'false');
      item.addEventListener('pointerenter',()=>setExpanded(true));
      item.addEventListener('pointerleave',()=>setExpanded(false));
      item.addEventListener('focusin',()=>setExpanded(true));
      item.addEventListener('focusout',event=>{if(!item.contains(event.relatedTarget))setExpanded(false)});
      item.addEventListener('keydown',event=>{
        if(event.key!=='Escape')return;
        setExpanded(false);
        trigger.focus();
      });
    });
  };

  const start=()=>init(document);
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});else start();
  document.addEventListener('shopify:section:load',event=>init(event.target));
})();
